import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Heading from 'components/Heading';
import MayaLayout from 'components/MayaLayout';
import StrategicImperativeForm from 'components/StrategicImperativeForm/StrategicImperativeForm';
import useStrategicImperativeEdit from 'routes/AuthenticatedApp/StrategicImperativeEdit/StrategicImperativeEdit.hook';
import Box from 'yoda-ui/components/Box';
import Loader from 'yoda-ui/components/Loader';

const StrategicImperativeEdit: FC = () => {
  const { t } = useTranslation();
  const {
    loading,
    strategicImperative,
    handleSaveStrategicImperativeForm,
    handleCancelStrategicImperativeForm,
  } = useStrategicImperativeEdit();

  return (
    <MayaLayout>
      <Heading>
        { t('maya_strategic_imperative_form_edit_title') }
      </Heading>
      {
        loading
          ? (
            <Box display="flex" flexDirection="column" justifyContent="center" height="100%">
              <Loader center />
            </Box>
          )
          : (
            <StrategicImperativeForm
              {
                ...{
                  strategicImperative,
                  submitCallback: handleSaveStrategicImperativeForm,
                  cancelCallback: handleCancelStrategicImperativeForm,
                }
              }
            />
          )
      }
    </MayaLayout>
  );
};

export default StrategicImperativeEdit;
